
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminal/download/previous-versions",
      function () {
        return require("private-next-pages/terminal/download/previous-versions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminal/download/previous-versions"])
      });
    }
  